import React from 'react';
import { RecordColumn, RecordList } from 'components/record-shell/RecordList';
import { PackageProduct } from 'types/package';

interface PackageProductsListProps {
  products: PackageProduct[];
  handleDeleteProduct(product: PackageProduct, index: number): void;
  handleEditProduct(product: PackageProduct, index: number): void;
}

const columns: RecordColumn[] = [
  { id: 'product', label: 'Produto' },
  { id: 'quantity', label: 'Quantidade', shortLabel: 'Qtd', align: 'right', width: '130px' },
];

const PackageProductsList: React.FC<PackageProductsListProps> = ({
  products,
  handleDeleteProduct,
  handleEditProduct,
}) => (
  <RecordList
    columns={columns}
    rows={products.map((product, index) => ({
      key: product.id || index,
      values: {
        product: product.product?.name || `Produto nº ${product.product_id}`,
        quantity: `${product.quantity} ${product.product?.unit || ''}`.trim(),
      },
    }))}
    onEdit={index => handleEditProduct(products[index], index)}
    onDelete={index => handleDeleteProduct(products[index], index)}
  />
);

export default PackageProductsList;
